import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './filmstudio/Header';
import Footer from './filmstudio/Footer';
import Home from './filmstudio/Home';
import Work from './filmstudio/Work';
import Crew from './filmstudio/Crew';
import Brief from './filmstudio/Brief';

export default function FilmStudioTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#0A0908]" data-testid="film-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }} data-testid={`film-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'work' && <Work setPage={setPage} />}
          {page === 'crew' && <Crew setPage={setPage} />}
          {page === 'brief' && <Brief setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
